// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wv-0";
export var confirmationIcon = "_wv-1";